var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.564,
    height: 18.564,
    viewBox: "0 0 18.564 18.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    d: "M0,11.569a1.5,1.5,0,0,1-1.5-1.5V0A1.5,1.5,0,0,1,0-1.5H10.184a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5H1.5v8.569A1.5,1.5,0,0,1,0,11.569Z",
    transform: "translate(4.7 9.322) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThick);
export default __webpack_public_path__ + "static/media/arrow-thick.02fb03c01acdebf5c764ab65d05eea1e.svg";
export { ForwardRef as ReactComponent };